import React from 'react';
import {
  List as RaList,
  TextField,
  EditButton,
  useGetIdentity,
} from 'react-admin';

import CustomizableDatagrid from '../../../utils/libs/CustomizableDatagridLib';
import { Filter } from './Filter';
import { CUSTOM_STORAGE } from '../../../constants/list-column-custom-storage';
import { usePageTitle } from '../../../components/usePageTitle';
import { withPermissions } from '../../../components/hoc/WithPermissions';
import { USER_ROLE } from '../../../constants/statuses';

const DEFAULT_COLUMNS = [
  'id',
  'name',
];

const List = (props) => {
  usePageTitle(props);
  const { loading: identityLoading } = useGetIdentity();

  if (identityLoading) {
    return null;
  }
  return (
    <RaList {...props} filters={<Filter />} bulkActionButtons={false}>
      <CustomizableDatagrid
        storage={CUSTOM_STORAGE}
        defaultColumns={DEFAULT_COLUMNS}
      >
        <TextField source="id" />
        <TextField source="name" />
        <EditButton />
      </CustomizableDatagrid>
    </RaList>
  );
};
export default withPermissions(List, null, [USER_ROLE.SUPER_ADMIN]);
